import React from 'react';
import { injectGlobal } from 'styled-components';
import PropTypes from 'prop-types';
import Tippy from 'tippy.js';

import { fontWeight } from '../../constants';
import '!style-loader!css-loader?modules=false!tippy.js/dist/tippy.css';

export default class LabelTooltip extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    theme: PropTypes.string,
    hideOnClick: PropTypes.bool,
    tippyHtml: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.instanceOf(Element),
    ]),
    manualShow: PropTypes.bool,
    trigger: PropTypes.string, // one or more of: ['mouseenter', 'focus', 'click', 'manual']
    interactive: PropTypes.bool,
    style: PropTypes.object,
  };

  static defaultProps = {
    position: 'bottom',
    theme: 'default',
    hideOnClick: true,
    tippyHtml: false,
    manualShow: false,
    trigger: 'mouseenter focus',
    style: {},
    interactive: false,
  };

  render() {
    return (
      <span
        ref={(span) => {
          this.span = span;
        }}
        title={this.props.text}
        aria-label={this.props.text}
        className={this.props.className}
        style={{ ...this.props.style, display: 'inline-block' }}
      >
        {this.props.children}
      </span>
    );
  }

  componentDidMount() {
    this.tippy = new Tippy(this.span, {
      arrow: true,
      position: this.props.position,
      animation: 'fade',
      duration: 200,
      theme: this.props.theme,
      hideOnClick: this.props.hideOnClick,
      html: this.props.tippyHtml,
      trigger: this.props.trigger,
      interactive: this.props.interactive,
    });
  }

  componentDidUpdate(prevProps) {
    if (!this.tippy) {
      return;
    }

    const popper = this.tippy.getPopperElement(this.span);
    this.tippy.update(popper);

    if (
      this.props.trigger === 'manual' &&
      prevProps.manualShow !== this.props.manualShow
    ) {
      this.props.manualShow ? this.tippy.show(popper) : this.tippy.hide(popper);
    }
  }

  componentWillUnmount() {
    if (!this.tippy) {
      return;
    }

    const popper = this.tippy.getPopperElement(this.span);
    this.tippy.destroy(popper);
  }
}

injectGlobal`
  .tippy-popper {
    ${fontWeight('heavy')}
  }
`;
